import(/* webpackMode: "eager" */ "/app/app/indicators/biblio/trends/page.jsx");
